import { useMemo } from 'react';
import { readCookie } from '@zapier/cookies';
import { AuthType } from '../../types';
import { AUTH_TYPE_COOKIE_NAME } from '../../constants';

export function useAuthType() {
  return useMemo(() => getAuthTypeFromCookie(), []);
}

function getAuthTypeFromCookie() {
  return readCookie(AUTH_TYPE_COOKIE_NAME) as AuthType | undefined;
}
